/**
 * @file steps
 * @author (gaojie15@baidu.com)
 */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
export default function viewmod(props) {
    const [isPC, setisPc] = useState(true);
    // const showImg = require('../../asset/img/attest/icon-qiye.jpg');
    // const searchImg = require('../../asset/img/attest/intro/search-view.png');
    const {phone, name, modTop} = props;
    let po = props.po || 'fixed';
    const phoneview = phone.split(',')[0];
    return <div className={'look-mod'} style={{top: `${modTop}px`, position: po}}>
        <div className={'title'}>
            <span className="lm-tg">
                <span onClick={() => setisPc(true)} className={isPC ? 'cur' : ''}>pc端</span>
                <span onClick={() => setisPc(false)} className={!isPC ? 'cur' : ''}>移动端</span>
            </span>
            预览效果（预览效果仅供参考，实际效果以线上为准）
        </div>
        <div className={'con'}>
            {isPC ? <div className="card">
                <div className="card-in">
                    <div className="title-wrapper">
                        <span className="titlex">{name ? name : '展示名称'}</span>
                    </div>
                    <span className="phone">{phoneview ? phoneview : 'xx-xx'}</span>
                </div>
            </div> : <div className="card-wise">
                <div className="card-in">
                    <div className="title-wrapper">
                        <span className="titlex">{name ? name : '展示名称'}</span>
                    </div>
                    <span className="phone">{phoneview ? phoneview : 'xx-xx'}</span>
                </div>
            </div>}
        </div>
        <div className="bottom-tip">
            <img
                src={require('../../asset/img/attest/icon_warn.svg')}
                alt=""
            />
            如有疑问，请添加QQ群725854778，私信管理员处理。
        </div>
    </div>;
}
viewmod.propTypes = {
    phone: PropTypes.string,
    name: PropTypes.string,
    modTop: PropTypes.number,
    po: PropTypes.any,
};
